import fetch from '../utils/fetch';
import { emailURL } from 'endpoints';

let emails = undefined;

class EmailSDK {
    getEmails() {
        if ( emails ) {
            return emails;
        }
        return fetch( `${ emailURL }` ).then(
            ( res ) => {
                if ( res.ok ) {
                    return res.json().then( ( data ) => {
                        emails = new Promise( ( resolve ) => resolve( data.emails ) );
                        return data.emails;
                    } );
                } else {
                    throw res.status;
                }
            }
        );
    }

    fetchEmail( emailId ) {
        return fetch( `${ emailURL }/${ emailId }` ).then(
            ( res ) => {
                if ( res.ok ) {
                    return res.json().then( ( data ) => {
                        return data;
                    } );
                } else {
                    throw res.status;
                }
            }
        );
    }

    getInputs( emailId, locale ) {
        return fetch( `${ emailURL }/${ emailId }/inputs`, {
            headers: { 'locale': locale }
        } ).then(
            ( res ) => {
                if ( res.ok ) {
                    return res.json().then( ( data ) => {
                        return data.inputs;
                    } );
                } else {
                    throw res.status;
                }
            }
        );
    }

    saveInputs( emailId, locale, inputs ) {
        return new Promise( ( resolve, reject ) => {
            fetch( `${ emailURL }/${ emailId }/inputs`, {
                method: 'POST',
                headers: { 'content-type': 'application/json' },
                body: JSON.stringify( { locale, inputs } )
            } )
            .then( ( res ) => {
                if ( res.ok ) {
                    res.json().then( ( inputs ) => {
                        resolve( inputs );
                    } );
                } else {
                    res.json().then( ( data ) => {
                        if ( data.error && data.error.stack ) {
                            console.error( JSON.parse( data.error.stack ) );
                        }
                        reject( data.error.description );
                    } );
                }
            } )
            .catch( ( err ) => {
                console.error( err );
                reject( err.message );
            } );
        } );
    }

    fetchPreview( previewRequest ) {
        return new Promise( ( resolve, reject ) => {
            fetch( `${ emailURL }/preview`, {
                method: 'POST',
                headers: { 'content-type': 'application/json' },
                body: JSON.stringify( previewRequest )
            } )
                .then( ( res ) => {
                        if ( res.ok ) {
                            res.json().then( ( res ) => {
                                resolve( res );
                            } );
                        } else {
                            res.json().then( ( data ) => {
                                if ( data.error && data.error.stack ) {
                                    console.error( JSON.parse( data.error.stack ) );
                                }
                                reject( data.error.description );
                            } );
                        }
                    } )
                .catch( ( err ) => {
                    console.error( err );
                    reject( err.message );
                } );
        } );
    }

    translate( emailBody, customOptions ) {
        const requestBody = {
            ...emailBody,
            customOptions
        };

        return new Promise( ( resolve, reject ) => {
            fetch( `${ emailURL }/translations`, {
                method: 'POST',
                headers: { 'content-type': 'application/json' },
                body: JSON.stringify( requestBody )
            } )
                .then( ( res ) => {
                        if ( res.ok ) {
                            res.json().then( ( res ) => {
                                resolve( res );
                            } );
                        } else {
                            res.json().then( ( error ) => {
                                if ( error && error.stack ) {
                                    console.error( error.stack );
                                }
                                reject ( error.message );
                            } );
                        }
                    } )
                .catch( ( err ) => {
                    console.warn( 'Error in email service - translate: ', err );
                    reject ( `Error in email service - ${ err ? err.code : 'unknown' }` );
                } );
        } );
    }
}

export default new EmailSDK();

